// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"b7ee8371","553":"33fc9283","631":"33fc9283","893":"33fc9283"}[chunkId] + ".chunk.css";
};